module.exports = __webpack_public_path__ + "img/bgbrand.82731a86.jpg";